"use client";
import useSWR from "swr";
import { basicFetcher } from "utils/fetcher";

export default function UnreadNotifs() {
  const { data = [] } = useSWR<Notif[]>("user-inbox/", basicFetcher);

  const unread = data.filter((i) => !i.is_read).length;

  return (
    <div className="relative">
      {!!unread && (
        <p className="inline-flex justify-center items-center bg-gold text-xs rounded-full w-5 h-5 text-white font-bold">
          {unread} <span className="sr-only">unread notification</span>
        </p>
      )}
    </div>
  );
}
